import {Button, Col, Form, Input, Row} from 'antd';
import React, {useContext} from 'react';
import {sideMenuContext} from '../../../router/IndexRouter';
import TextArea from 'antd/es/input/TextArea';

const layout = {
	labelCol: {span: 8},
	wrapperCol: {span: 16},
};
const tailLayout = {
	wrapperCol: {offset: 4, span: 16},
};

const DetailSocietyRecognition = () => {
	const {currentItem} = useContext(sideMenuContext);
	const [form] = Form.useForm();

	return (
		<Form
			{...layout}
			form={form}
			initialValues={currentItem}
			name="control-hooks"
			style={{maxWidth: 1200, marginLeft: 40}}
		>
			<Row align="top">
				<Col span={12}>
					<Form.Item name="prizeYear" label="授奖年度" rules={[{required: true, message: '内容不能为空'}]}>
						<Input disabled={true}/>
					</Form.Item>
				</Col>
				<Col span={12}>
					<Form.Item name="prizeName" label="授奖名称" rules={[{required: true, message: '内容不能为空'}]}>
						<Input disabled={true}/>
					</Form.Item>
				</Col>
			</Row>

			<Row align="top">
				<Col span={24}>
					<Form.Item
						labelCol={{span: 4}}
						wrapperCol={{span: 20}}
						name="prizeMemo" label="说明" rules={[{required: true, message: '内容不能为空'}]}>
						<TextArea rows={4} disabled={true}/>
					</Form.Item>
				</Col>
			</Row>

			<Row align="top">
				<Col span={24}>
					<Form.Item
						labelCol={{span: 4}}
						wrapperCol={{span: 20}}
						name="prizeContent" label="详细信息" rules={[{required: true, message: '内容不能为空'}]}>
						<div style={{marginTop: 4}} dangerouslySetInnerHTML={{__html: currentItem.prizeContent}}/>
					</Form.Item>
				</Col>
			</Row>

			<Form.Item {...tailLayout}>
				<Button
					type="primary"
					htmlType="button"
					onClick={() => {
						window.history.back();
					}}
				>
					返回
				</Button>
			</Form.Item>
		</Form>
	);
};

export default DetailSocietyRecognition;